<template>
  <div class="d-flex justify-content-between" v-if="allItems.length">
    <div class="text-right m-4">
      <h5 style="font-size: 1vw !important"></h5>
    </div>
    <div class="d-flex">
      <a v-if="allItems.length" :href="`${this.download_url}/KeyActivitiesProblem/all/word/${id_user}`" style="margin-top: 1.3vw;"
         class="btn btn-primary btn-submit-1">خروجی Word</a>
      <a v-if="allItems.length" :href="`${this.download_url}/KeyActivitiesProblem/all/pdf/${id_user}`"
         style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 1vw;" class="btn btn-primary btn-submit-1">خروجی
        PDF</a>
      <a :href="`${this.download_url}/KeyActivitiesProblem/all/excel/${id_user}`"
         style="margin-top: 1.3vw;margin-left: 1vw; " class="btn btn-primary btn-submit-1">
         برون ریزی</a>
      <a @click.prevent="importModal=true"
         style="margin-top: 1.3vw;margin-left: 2vw; " class="btn btn-primary btn-submit-1">
         درون ریزی</a>

      <a v-if="allItems.length"   style="margin-top: 1.3vw;margin-left: 1vw; margin-right: -1.1vw; " class="btn btn-primary btn-submit-1 "
            :style="!status_show ? 'background-color: red; border-color: red' : 'background-color: green; border-color: green'"
            @click="acceptComplete"
      >
        <div v-if="!status_loading">

          <span v-if="!status_show">  تایید وضعیت</span>
          <span v-else>عدم تایید</span>
        </div>
        <div v-else>
          <div class="loader-line"></div>

        </div>
      </a>
    </div>

  </div>
  <div class="table-responsive p-5" style="overflow-x:scroll; ">
    <center v-show="!allItems.length">
      اطلاعاتی یافت نشد
    </center>
    <div style="overflow-y: scroll; height: 50vw;" :style="allItems.length < 19 ? 'height: auto;' : ''">


    <table class="table table-striped" v-show="allItems.length" style="width: 140vw;">
      <tbody>
      <tr>
        <th><strong>ردیف</strong></th>
        <th style="width: 12vw;"><strong>
          مسئله
        </strong></th>
        <th><strong> سیاست مداخله</strong></th>

        <th style="width: 7vw;"><strong>
          اقدام پیشران / پشتیبان
        </strong></th>
        <th style="width: 7vw;"><strong> زمان شروع اقدام </strong></th>
        <th style="width: 7vw;"><strong> زمان پایان اقدام </strong></th>
        <th style="width: 7vw;"><strong> فعالیت‌ کلیدی </strong></th>
        <th style="width: 7vw;"><strong> دستگاه‌ همکار </strong></th>
        <th style="width: 7vw;"><strong>تاریخ شروع فعالیت</strong></th>
        <th style="width: 7vw;"><strong>تاریخ پایان فعالیت</strong></th>
        <th style="width: 5vw;"><strong>مستندات پیشرفت فعالیت‌ها </strong></th>
        <th><strong> هدف فصل بهار </strong></th>
        <th><strong> میزان پیشرفت فصل بهار </strong></th>


        <th><strong>میزان انحراف از هدف </strong></th>
        <th><strong>مهم‌ترین موانع عدم تحقق برنامه </strong></th>
        <th><strong>راهکار پیشنهادی </strong></th>




      </tr>

      <tr class="bg-white" v-for="(item, index) in allItems">
        <td>{{ index + 1 }}</td>
        <td>
          {{ item.problem && item.problem.title }}
        </td>
        <td>
          {{ item.problem && item.problem.basic_measures_problem && item.problem.basic_measures_problem.intervention_policy }}
        </td>
        <td>
          {{ item.propulsion_basic_action && item.propulsion_basic_action.title  }}
        </td>
        <td>
          {{ item.propulsion_basic_action && item.propulsion_basic_action.date_start }}
        </td>
        <td>
          {{ item.propulsion_basic_action && item.propulsion_basic_action.date_end }}
        </td>
        <td>
          {{ item.title }}
        </td>

        <td>
          {{ item.partner_device }}
        </td>

        <td>
          {{ item && item.start_date }}

        </td>
        <td>
          {{ item && item.end_date }}

        </td>
        <td>
          <div class="d-flex align-items-center justify-content-center">
            <button @click.prevent="addDoc(item.title,item.id)" class="btn btn-primary btn-submit-1">تکمیل/بروزرسانی</button>
          </div>
        </td>

        <td style="width: 7vw; ">
          <input style="text-align: center" @keyup="calculatedValue(item.id)" :value="item.device_monitoring && item.device_monitoring.spring_progress" :id="`inputOne_${item.id}`" type="number" class="form-control">
        </td>
        <td style="width: 7vw; ">
          <input style="text-align: center" @keyup="calculatedValue(item.id)"  :value="item.device_monitoring && item.device_monitoring.summer_progress" :id="`inputTwo_${item.id}`" type="number" class="form-control">
        </td>


        <td style="width: 7vw; ">
          <input style="text-align: center" disabled  :value="item.device_monitoring?.summer_progress ?? (item.device_monitoring?.summer_progress - item.device_monitoring?.spring_progress < 0 ? 0 : item.device_monitoring?.summer_progress - item.device_monitoring?.spring_progress)" :id="`inputSeven_${item.id}`" type="number" class="form-control">
        </td>

        <td>
          <input  :value="item.device_monitoring && item.device_monitoring.important_obstacles" :id="`inputNine_${item.id}`" type="text" class="form-control">
        </td>
        <td>
          <input  :value="item.device_monitoring && item.device_monitoring.approach" :id="`inputTen_${item.id}`" type="text" class="form-control">
        </td>




      </tr>


      </tbody>
    </table>
  </div>
  </div>
  <center v-if="show_insert" v-show="allItems.length">
    <hr class="w-75 my-1">
    <button @click.prevent="store" class="btn btn-submit-1 btn-primary my-2">ذخیره</button>
  </center>
  <div class="modal__error bg-white" style="z-index: 9699; width: 54vw;" v-show="documentsModal">
    <div class="d-flex justify-content-between">
      <p>{{titleDoc}}</p>
      <p @click.prevent="documentsModal=!documentsModal">❌</p>
    </div>
    <hr>
    <div class="d-flex flex-column" v-if="show_insert">
      <label>     عنوان مستندات پیوست  </label>
      <input v-model="title_attach" type="text" class="form-control">
    </div>
    <div class="d-flex flex-column" v-if="show_insert">
      <label>      فایل   پیوست  </label>
      <input   type="file" class="form-control" style="display:block;"  ref="fileInput">
    </div>
    <center class="my-2" v-if="show_insert">
      <button @click="addDocs" class="btn btn-primary btn-submit-1">افزودن </button>
    </center>
    <hr class="my-3 w-100" v-if="show_insert">
    <table class="table table-striped bg-white">

      <tbody>
      <tr>
        <th ><strong> عنوان مستند    </strong></th>
        <th><strong>فایل مستند</strong></th>
        <th v-if="show_insert" style="width: 1vw;"><strong>عملیات  </strong></th>
      </tr>
      <tr class="bg-white" v-for="(item) in documents">
        <td>{{item.title}}</td>
        <td>
          <a :href="`${this.download_url}/${item.file}`" target="_blank">مشاهده</a>
        </td>
        <td v-if="show_insert">
          <a @click.prevent="deleteMethodFile(item.id)" style="margin-right: 0.3vw;"   href="#"><img  class="table-delete-img" src="/img/delete.f9fc94bc.svg" alt="delete"></a>

        </td>
      </tr>
      </tbody>


    </table>

  </div>
  <div class="modal__error bg-white" style="z-index: 9699; width: 54vw;" v-show="importModal">
    <div class="d-flex flex-row justify-content-between">
      <p>درون ریزی</p>
      <p @click="importModal=!importModal">❌</p>
    </div>
  <div style="border: 1px solid #777; padding: 1vw; border-radius: 1vw">
    <input ref="fileInputTwo"  type="file" class="form-control" style="display:block;" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" >
    <div class="d-flex align-items-center justify-content-center">
      <button @click.prevent="importExcel" class="btn btn-submit-1 btn-primary my-2">ذخیره</button>

    </div>
  </div>

  </div>

  <div dir="rtl" class="modal__error slide-top" v-show="delete_fileModal" style="z-index: 999999999999999; top: 40%;">
    <div class="d-flex justify-content-between w-100">
      <p>حذف</p>
      <p @click="delete_fileModal=!delete_fileModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="delete_fileModal=!delete_fileModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteMethodFileSubmit(id_file)">تایید</button>
      </div>
    </div>
  </div>

</template>
<script>
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'
import {useToast} from "vue-toastification";

const toast = useToast();

export default {
  components: {Vue3PersianDatetimePicker},
  data() {
    return {
      importModal: false,
      documentsModal: false,
      MissionModal: false,
      KeyDefinitionsModal: false,
      allItems: [],
      documents: [],
      id: '',
      title: '',
      titleDoc: '',
      title_attach: '',
      file: '',
      id_two: '',

      target: '',

      title_task: '',
      trustee_device: '',
      partner_device: '',
      start_date_task: '',
      end_date_task: '',
      expected_progress: '',
      key_activities_problems_id: '',
      spring_progress: '',
      summer_progress: '',
      autumn_progress: '',
      winter_progress: '',
      progress: '',
      deviation: '',
      important_obstacles: '',
      approach: '',
      year_funds: '',
      spring_funds: '',
      summer_funds: '',
      autumn_funds: '',
      winter_funds: '',
      id_user: '',
      id_file: '',
      delete_fileModal: false,
      status_show: false,
      status_loading: false,
      show_insert: false,
    }
  },
  methods: {
    setShow(){
      if (this.$cookies.isKey('type_2')){
        if (this.status_show===false){
          this.show_insert = true
          return;
        }
        this.show_insert = true
      }
      this.show_insert = false
    },
    acceptComplete(){
      if (this.status_loading){
        return;
      }
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/KeyActivitiesProblem/update_complete`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message){
              toast.success(response.message)
              this.status_show=!this.status_show
              this.status_loading = false
              this.all()
            }

          })
          .catch();
    },
    deleteMethodFile(id){
      this.id_file = id
      this.delete_fileModal = true
    },
    deleteMethodFileSubmit(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/DeviceMonitoringCareForProblem/remove_doc/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            const message = response.message
            if (message){
              toast.success(message)
              this.delete_fileModal = false
              this.id_file = ''
              this.allDocsMethod(response.id)

            }
          })
          .catch();
    },
    importExcel(){
      const file = this.$refs.fileInputTwo.files[0]
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('title', this.title_attach)
      formdata.append('file', file)
      formdata.append('id', this.id)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/DeviceMonitoringCareForProblem/import`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)
            this.$refs.fileInputTwo.value = ''
            this.all()
            this.importModal=false

          })
          .catch();
    },
    allDocsMethod(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/DeviceMonitoringCareForProblem/total_doc/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            this.documents.length=0
            response.all.forEach((item)=>{
              this.documents.push(item)
            })


          })
          .catch();
    },
    addDocs(){
      const file = this.$refs.fileInput.files[0]
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('title', this.title_attach)
      formdata.append('file', file)
      formdata.append('id', this.id)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/DeviceMonitoringCareForProblem/save_doc`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)
            this.$refs.fileInput.value = ''
            this.title_attach = ''
            this.allDocsMethod(this.id)

          })
          .catch();



    },
    addDoc(title,id){
      this.id=id
      this.titleDoc=title
      this.allDocsMethod(this.id)
      this.documentsModal=true
    },
    calculatedValue(id){
      let result = 0
      const one = document.querySelector(`#inputTwo_${id}`).value
      const two = document.querySelector(`#inputOne_${id}`).value
      let calc = two-one
      if (calc<0){
        result=0
        document.querySelector(`#inputSeven_${id}`).value = result
        return
      }
      result=calc
      document.querySelector(`#inputSeven_${id}`).value = result

    },





    all() {

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/KeyActivitiesProblem/all_monitoring`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            if (response.status){
              this.status_show = true
            }
            this.allItems.length = 0
            response.all.forEach((item) => {

              this.allItems.push(item)

            })
            this.setShow()
          })
          .catch();
    },
    store() {
      let obj = []
      this.allItems.forEach((item) => {
        const inputOne= document.getElementById(`inputOne_${item.id}`).value
        const inputTwo = document.getElementById(`inputTwo_${item.id}`).value
        const inputSeven = document.getElementById(`inputSeven_${item.id}`).value
         const inputNine = document.getElementById(`inputNine_${item.id}`).value
        const inputTen = document.getElementById(`inputTen_${item.id}`).value



        let record = {
          'key_id': item.id,
          'spring_progress': inputOne,
          'summer_progress':inputTwo,
          'deviation': inputSeven,
          'important_obstacles':inputNine,
          'approach':inputTen,
          'id': item.device_monitoring ? item.device_monitoring.id  : null

        }
        obj.push(record)
      })

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('all', JSON.stringify(obj))
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/DeviceMonitoringCareForProblem/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)

          })
          .catch();
    },
    fetchItems() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/show`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error){
              this.logout()
              return;
            }
            if (result['item']) {
               if (this.is_mother){
              this.id_user = result['item']['id']
                return;
              }
              this.id_user = result['item']['company_id']

            }

          })
          .catch();
    },
  },
  mounted() {
    this.all()
    this.fetchItems()
  }
}
</script>
<style scoped>

</style>